var _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polyline, _polyline2, _polygon10, _polygon11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "846.5 972.5 96 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Flag of the United Kingdom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 846.5,
    y: 972.5,
    width: 95.95,
    height: 47.995,
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "889.68 1001.3 889.68 1020.5 899.27 1020.5 899.27 1001.3 942.45 1001.3 942.45 991.69 899.27 991.69 899.27 972.5 889.68 972.5 889.68 991.69 846.5 991.69 846.5 1001.3",
    fill: "#CF142B"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "902.47 988.04 902.47 972.5 933.54 972.5",
    fill: "#00247D"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "902.47 1005 902.47 1020.5 933.54 1020.5",
    fill: "#00247D"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "886.48 1005 886.48 1020.5 855.41 1020.5",
    fill: "#00247D"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "886.48 988.04 886.48 972.5 855.41 972.5",
    fill: "#00247D"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "846.5 976.96 846.5 988.5 869.57 988.5",
    fill: "#00247D"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "942.45 976.96 942.45 988.5 919.38 988.5",
    fill: "#00247D"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "942.45 1016 942.45 1004.5 919.38 1004.5",
    fill: "#00247D"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "846.5 1016 846.5 1004.5 869.57 1004.5",
    fill: "#00247D"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "942.45 972.5 937.12 972.5 905.19 988.5 910.52 988.5 942.5 972.5",
    fill: "#CF142B"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "883.76 1004.5 878.43 1004.5 846.5 1020.5 851.83 1020.5 883.81 1004.5",
    fill: "#CF142B"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "873.15 988.51 878.48 988.51 846.5 972.5 846.5 975.18",
    fill: "#CF142B"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "915.79 1004.5 910.46 1004.5 942.43 1020.5 942.43 1017.8",
    fill: "#CF142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/UnitedKingdom.f8e87a8eac8d41d37ba03f82d547ac49.svg";
export { ForwardRef as ReactComponent };